import { Component, OnInit } from '@angular/core';
import { Gas,Pipe } from 'projects/pumpcalc-core/src/lib/datatypes.service';
import { GasService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';
import { ResultsService } from '../results.service';

@Component({
  selector: 'app-calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['./calculation.component.css']
})
export class CalculationComponent implements OnInit {

  result = [];
  conditions = {};
  lastSystemResult = [];
  lastComplexResult= [];
  pipes = [new Pipe("1")];
  gas:Gas = new Gas();
  showComplex=false;
  gases;
  mixedResults=[];
  rangedResult=[];
  numResults=0;
  diagramResult;
  rangeVariable;
  diagramTitle;
  isEditing=true;
  preview=environment.preview;

  constructor(private gasService: GasService, private resultsService:ResultsService) { }

  ngOnInit(): void {
    this.gasService.getGases().subscribe(gases=>{
      this.gas = gases[0];
    },error=>{
      console.log(error);
    })
  }

  addResult(solverResult){
    // !! mock ranged result start
    // solverResult = mockRangedResultSolverResultsAndConditonsAndRangeVariable.solverResult;
    // this.conditions = mockRangedResultSolverResultsAndConditonsAndRangeVariable.conditions;
    // this.rangeVariable = mockRangedResultSolverResultsAndConditonsAndRangeVariable.rangeVariable;
    // !! mock ranged result end
    this.diagramTitle = "";
    this.diagramResult=this.conditions;
    this.rangedResult = [];
    if(solverResult.results.length > 1){
      this.rangedResult = [{solverResult:solverResult,conditions:this.clone(this.conditions),rangeVariable:this.clone(this.rangeVariable)}];
      return;
    }
    this.mixedResults.push({solverResult:solverResult,conditions:this.clone(this.conditions),rangeVariable:this.clone(this.rangeVariable)})
    this.mixedResults = this.clone(this.mixedResults);
    this.numResults++;
    this.diagramResult = this.resultsService.systemResult(solverResult.results[0],this.clone(this.conditions),"#"+this.numResults,false);
    this.diagramTitle = "#"+this.numResults;
  }

  updateParameters(parameters:{pipes:Pipe[],conditions:any,gas:Gas,rangeVariables:any}){
    this.pipes = JSON.parse(JSON.stringify(parameters.pipes));
    this.gas = parameters.gas;
    this.conditions = parameters.conditions;
    this.diagramResult = this.conditions;
    this.rangeVariable = parameters.rangeVariables;
  }

  clone(obj:any):any{
    return JSON.parse(JSON.stringify(obj));
  }

}



